import createKindeClient, { type KindeClient } from "@kinde-oss/kinde-auth-pkce-js";

let kindeClientInstance: KindeClient | null = null;

async function getAuthClient(): Promise<KindeClient> {
  if (!kindeClientInstance) {
    kindeClientInstance = await createKindeClient({
      client_id: import.meta.env.VITE_KINDE_CLIENT_ID,
      domain: import.meta.env.VITE_KINDE_AUTHORITY,
      redirect_uri: import.meta.env.VITE_KINDE_REDIRECT_URI,
      logout_uri: import.meta.env.VITE_KINDE_REDIRECT_URI?.replace("/auth/login-callback", "/auth/login"),
      scope: import.meta.env.VITE_KINDE_SCOPE,
      audience: "https://api.debitroom",
      on_error_callback: (error) => {
        console.error(error.error);
        console.error(error.errorDescription);
        console.error(error.state);
        console.error(error.appState);
      },
    });
  }
  return kindeClientInstance;
}

export { getAuthClient };
